var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.updateCardKey, staticClass: "network-rule" },
    [
      !_vm.selectedNetworkRule
        ? _c("div", { staticClass: "no network-rule-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SelectNetworkRule")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedNetworkRule
        ? _c(
            "div",
            { staticClass: "network-rule-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.cardObjectIdentifier,
                  "identifier-label": _vm.$tc("Label", 1),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    !_vm.creatingNetworkRule &&
                    _vm.userHasPermission("network_rule_update"),
                  "card-label": _vm.cardLabel,
                  height: _vm.cardHeight
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateNetworkRule
                }
              }),
              _vm._v(" "),
              _c("network-rule-specific-info", {
                attrs: {
                  "network-rule-data": _vm.networkRule.data,
                  "network-rule-id": _vm.networkRule.id,
                  "editing-data": _vm.editingData,
                  requiredFieldsFilled: _vm.requiredFieldsAreFilled,
                  "submit-button-label": _vm.submitButtonLabel
                },
                on: {
                  "update-specific-field": _vm.updateNetworkRuleSpecificField,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  },
                  "save-material": function($event) {
                    _vm.saveChangesDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-738f3888", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738f3888","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemSettingsManagement/NetworkRules/NetworkRule.vue
// module id = null
// module chunks = 